/**
 * i18n Constants
 *
 * Shared constants for i18n configuration
 */

/**
 * LocalStorage key for persisting language preference
 */
export const LANGUAGE_STORAGE_KEY = 'ai_commerce_language' as const
